import React, { useState, useEffect } from "react";
import { useGetProductImagesQuery, useGetProductsQuery, useDeleteProductMutation, useCreateProductMutation, useUpdateProductMutation, useCloneProductMutation, useGetCategoryQuery, useCreateProductQuestionsMutation, useGetProductQuestionsMutation, useDeleteProductQuestionMutation,useCreateProductWinningMutation,useGetProductWinningMutation, useDeleteProductWinningMutation, useUpdateProductWinningMutation, useCreateProductComboWinningMutation, useGetProductComboWinningMutation, useDeleteProductComboWinningMutation, useUpdateProductComboWinningMutation } from "state/api";
import { Header, ImageDialog, Button, Input, Card, CardContent, CardDescription, CardHeader, CardTitle, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Separator, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "components";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Edit, Trash2, Image, Plus, Upload, Filter, Search, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Loader2, Copy, MoreHorizontal, HelpCircle, Trophy, ListOrdered, Layers, Save, X } from "lucide-react";
import ProductWishSidebar from "components/ProductWishSidebar";
import { sortedWinningDocuments } from "utils/prizeDisplay";

const normalizeWinningRows = (response) => {
  const rows = response?.data ?? response ?? [];
  return sortedWinningDocuments(Array.isArray(rows) ? rows : []);
};

const Products = () => {
  const { data: productsResponse, isLoading, refetch } = useGetProductsQuery();
  
  // Handle different data structures from API
  const data = productsResponse?.data || productsResponse?.products || productsResponse || [];
  
  // Debug: Log products data
  console.log("Products API Response:", productsResponse);
  console.log("Products data:", data);
  console.log("Products length:", data?.length);
  console.log("First product:", data?.[0]);
  console.log("Data type:", typeof data);
  console.log("Is array:", Array.isArray(data));
  const [open, setOpen] = useState(false);
  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [cloneProductId, setCloneProductId] = useState(null);
  const [productWishSidebarOpen, setProductWishSidebarOpen] = useState(false);
  const [productForWishes, setProductForWishes] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const { data: categoryData, isLoading: categoryLoading } = useGetCategoryQuery();
  const [productId, setProductId] = useState(); // Images for the product
  const [deleteProduct, { isLoading: LoadingDelete }] = useDeleteProductMutation();
  const [cloneProduct, { isLoading: LoadingClone }] = useCloneProductMutation();
  const [createProduct, { isLoading: LoadingCreate }] = useCreateProductMutation();
  const [updateProduct, { isLoading: LoadingUpdate }] = useUpdateProductMutation();
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [productImagesProductId, setProductImagesProductId] = useState(null);
  const { data: imagesData = [] } = useGetProductImagesQuery(productImagesProductId, {
    skip: !imageDialogOpen || !productImagesProductId,
  });
  const [productQuestions, { isLoading: LoadingProductQuestionLoading }] = useGetProductQuestionsMutation();
  const [productWinnings, { isLoading: LoadingProductWinnings }] = useGetProductWinningMutation();
  const [createProductQuestion, { isLoading: LoadingProuctQuestionCreate }] = useCreateProductQuestionsMutation();
  const [deleteProductQuestion, { isLoading: LoadingProductQuestionDelete }] = useDeleteProductQuestionMutation();
  const [createProductWinning, { isLoading: LoadingProductWinning }] = useCreateProductWinningMutation();
  const [deleteProductWinning, { isLoading: LoadingProductDeleteWinning }] = useDeleteProductWinningMutation();
  const [updateProductWinning] = useUpdateProductWinningMutation();
  const [productComboWinnings, { isLoading: LoadingProductComboWinnings }] = useGetProductComboWinningMutation();
  const [createProductComboWinning] = useCreateProductComboWinningMutation();
  const [deleteProductComboWinning] = useDeleteProductComboWinningMutation();
  const [updateProductComboWinning] = useUpdateProductComboWinningMutation();
  

  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [terms, setTerms] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [productType, setProductType] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [totalWish, setTotalWish] = useState("");
  const [deductingWish, setDeductingWish] = useState("");
  const [totalQuestions, setTotalQuestions] = useState("");
  const [status, setStatus] = useState(false);
  const [isFirstWinnerGotProduct, setIsFirstWinnerGotProduct] = useState("");
  const [imageName, setImageName] = useState('');
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [productAllQuestions, setProductAllQuestions] = useState([]);
  const [productAllWinning, setProductAllWinning] = useState([]);
  const [comboDialogOpen, setComboDialogOpen] = useState(false);
  const [productAllComboWinning, setProductAllComboWinning] = useState([]);
  const [comboEdits, setComboEdits] = useState({});
  const [comboForm, setComboForm] = useState({
    comboRanks: '',
    amount: '',
    prizeType: 'CASH',
    label: '',
  });
  const [totalWishCount, setTotalWishCount] = useState([]);
  const [isPlayable, setIsPlayable] = useState("");

  const [isTimeBasedEvent, setIsTimeBasedEvent] = useState("0");
  const [isHomeFeatured, setIsHomeFeatured] = useState(false);
  const [featuredToggleId, setFeaturedToggleId] = useState(null);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  

  const [questionTypes, setQuestionTypes] = useState([]);
  const [questionDialogOpen, setQuestionDialogOpen] = useState(false);

  const [wishDialogOpen, setWishDialogOpen] = useState(false);
  const [productLegacyFirstPrize, setProductLegacyFirstPrize] = useState("CASH");
  const [wishRanges, setWishRanges] = useState([
    { range: '', percentage: '', amount: '', prizeType: 'CASH' },
  ]);
  const [productQuestionCount,setProductQuestionCount] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    const updatedWishRanges = wishRanges.map(wish => ({
      ...wish,
      amount: (productPrice * (parseFloat(wish.percentage || 0) / 100)).toFixed(2)
    }));
    setWishRanges(updatedWishRanges);
  }, []);

  const handleWishDialogOpen = async (productId, price, wishCount, legacyFirstPrize = "CASH") => {
    const allWinnings = await productWinnings(productId);
    setProductAllWinning(normalizeWinningRows(allWinnings));
    setWishDialogOpen(true);
    setProductId(productId);
    setProductPrice(price);
    setTotalWishCount(wishCount);
    setProductLegacyFirstPrize(legacyFirstPrize || "CASH");
  };

  const handleWishDialogClose = () => {
    setWishDialogOpen(false);
  };

  const handleAddWishRange = () => {
    setWishRanges([
      ...wishRanges,
      { range: '', percentage: '', amount: '', prizeType: 'CASH' },
    ]);
  };

  const handleRemoveWishRange = (index) => {
    const newWishRanges = wishRanges.filter((_, i) => i !== index);
    setWishRanges(newWishRanges);
  };

  const handleWishRangeChange = (index, field, value) => {
    const newWishRanges = wishRanges.map((wishRange, i) =>
      i === index ? { ...wishRange, [field]: value, amount: field === 'percentage' ? (productPrice * (parseFloat(value || 0) / 100)).toFixed(2) : wishRange.amount } : wishRange
    );
    setWishRanges(newWishRanges);
  };

  const handleUpdateWish = async () => {
    let totalPercentage = 0;
    wishRanges.forEach(wish => {
      totalPercentage += parseFloat(wish.percentage);
    });

    if (totalPercentage !== 100) {
      // toast.error('Total percentage must equal 100%', {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
      // return;
    }

    const distributedWishes = wishRanges.map(wish => ({
      range: wish.range,
      amount: (productPrice * (parseFloat(wish.percentage) / 100)).toFixed(2)
    }));

    // console.log(distributedWishes);
    // Logic to handle distributed wishes (e.g., save to backend)

    if (distributedWishes.length > 0) {
      for (let i = 0; i < distributedWishes.length; i++) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
       await createProductWinning({
          winrange: distributedWishes[i]["range"],
          productId: productId,
          winpercent: wishRanges[i]["percentage"],
          amount: distributedWishes[i]["amount"],
          prizeType: wishRanges[i]["prizeType"] || "CASH",
        });
      }
    }

    
    toast.success('Wishes updated successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    const allWinnings = await productWinnings(productId);
    setProductAllWinning(normalizeWinningRows(allWinnings));
  };

  const handleQuestionDialogOpen = async (productId,totalQuestions) => {
    setProductAllQuestions([]);
    const allQuestions = await productQuestions(productId);
    setProductAllQuestions(allQuestions.data);
    setProductId(productId);
    setProductQuestionCount(totalQuestions);
    setQuestionDialogOpen(true);
  };

  const handleQuestionDialogClose = () => {
    setQuestionDialogOpen(false);
  };

  const handleAddQuestionType = () => {
    setQuestionTypes([...questionTypes, { type: '', count: '', id: '' }]);
  };

  const handleRemoveQuestionType = (index) => {
    const newQuestionTypes = questionTypes.filter((_, i) => i !== index);
    setQuestionTypes(newQuestionTypes);
  };

  const handleQuestionTypeChange = (index, field, value) => {
    const newQuestionTypes = questionTypes.map((questionType, i) =>
      i === index ? { ...questionType, [field]: value } : questionType
    );
    setQuestionTypes(newQuestionTypes);
  };

  const handleUpdateQuestion = async () => {
    // console.log(questionTypes);
    if (questionTypes.length > 0) {
      for (let i = 0; i < questionTypes.length; i++) {
        await createProductQuestion({ questionFormat: questionTypes[i]["type"], productId: productId, questionCount: questionTypes[i]["count"] });

      }
    }
    toast.success('Question add to this product  successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setQuestionTypes([]);
    const allQuestions = await productQuestions(productId);
    setProductAllQuestions(allQuestions.data);
  }

  const handleDeleteQuestion = async (id) => {
    console.log(id);
    await deleteProductQuestion(id);
    toast.success('Question Delete  successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    const allQuestions = await productQuestions(productId);
    setProductAllQuestions(allQuestions.data);
  }

  const handleDeleteProductWinning = async (id) => {
    console.log(id);
    await deleteProductWinning(id);
    toast.success('Product Winning Delete successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    const allWinnings = await productWinnings(productId);
    setProductAllWinning(normalizeWinningRows(allWinnings));
  }

  const resolveExistingPrizeType = (question) => {
    if (question.prizeType === "PRODUCT" || question.prizeType === "CASH") {
      return question.prizeType;
    }
    if (question.winrange === "1") {
      return productLegacyFirstPrize === "PRODUCT" ? "PRODUCT" : "CASH";
    }
    return "CASH";
  };

  const handleUpdateExistingWinningPrizeType = async (winningId, prizeType) => {
    await updateProductWinning({ id: winningId, prizeType });
    toast.success(`Prize type updated to ${prizeType}`, {
      position: "top-right",
      autoClose: 3000,
    });
    const allWinnings = await productWinnings(productId);
    setProductAllWinning(normalizeWinningRows(allWinnings));
  };

  const buildComboEdits = (combos) => {
    const edits = {};
    (combos || []).forEach((combo) => {
      edits[combo._id] = {
        prizeType: combo.prizeType || 'CASH',
        label: combo.label || '',
        amount: combo.amount || '',
      };
    });
    return edits;
  };

  const handleComboDialogOpen = async (productId) => {
    const allCombos = await productComboWinnings(productId);
    const combos = allCombos.data || [];
    setProductAllComboWinning(combos);
    setComboEdits(buildComboEdits(combos));
    setComboDialogOpen(true);
    setProductId(productId);
    setComboForm({ comboRanks: '', amount: '', prizeType: 'CASH', label: '' });
  };

  const handleComboDialogClose = () => {
    setComboDialogOpen(false);
    setComboEdits({});
  };

  const handleComboEditChange = (id, field, value) => {
    setComboEdits((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleCreateComboWinning = async () => {
    const rankParts = comboForm.comboRanks.split(',').map((s) => s.trim()).filter(Boolean);
    if (rankParts.length < 2) {
      toast.error('Enter at least 2 ranks separated by commas (e.g. 100,150,200)');
      return;
    }
    if (comboForm.prizeType === 'PRODUCT') {
      if (!comboForm.label?.trim()) {
        toast.error('Enter a product name for the PRODUCT prize');
        return;
      }
    } else if (!comboForm.amount || parseFloat(comboForm.amount) <= 0) {
      toast.error('Enter a valid prize amount');
      return;
    }

    try {
      await createProductComboWinning({
        productId,
        comboRanks: comboForm.comboRanks,
        amount: comboForm.amount || '0',
        prizeType: comboForm.prizeType,
        label: comboForm.label,
      });

      toast.success('Combo winning created!');
      setComboForm({ comboRanks: '', amount: '', prizeType: 'CASH', label: '' });
      const allCombos = await productComboWinnings(productId);
      const combos = allCombos.data || [];
      setProductAllComboWinning(combos);
      setComboEdits(buildComboEdits(combos));
    } catch (error) {
      toast.error(error?.data?.message || error?.message || 'Failed to create combo winning');
    }
  };

  const handleDeleteComboWinning = async (id) => {
    await deleteProductComboWinning(id);
    toast.success('Combo winning deleted');
    const allCombos = await productComboWinnings(productId);
    const combos = allCombos.data || [];
    setProductAllComboWinning(combos);
    setComboEdits(buildComboEdits(combos));
  };

  const handleSaveComboWinning = async (id) => {
    const edit = comboEdits[id];
    if (!edit) return;

    const prizeType = edit.prizeType || 'CASH';
    const label = edit.label?.trim() || '';
    const amount = edit.amount?.trim() || '';

    if (prizeType === 'PRODUCT') {
      if (!label) {
        toast.error('Enter a product name before saving');
        return;
      }
    } else if (!amount || parseFloat(amount) <= 0) {
      toast.error('Enter a valid prize amount before saving');
      return;
    }

    try {
      await updateProductComboWinning({
        id,
        prizeType,
        label: label || undefined,
        amount: prizeType === 'CASH' ? amount : edit.amount || '0',
      });
      toast.success('Combo winning saved');
      const allCombos = await productComboWinnings(productId);
      const combos = allCombos.data || [];
      setProductAllComboWinning(combos);
      setComboEdits(buildComboEdits(combos));
    } catch (error) {
      toast.error(error?.data?.message || error?.message || 'Failed to save combo winning');
    }
  };

  

  const handleImageDialogOpen = (id) => {
    setProductId(id);
    setProductImagesProductId(id);
    setImageDialogOpen(true);
  };

  const handleImageDialogClose = () => {
    setImageDialogOpen(false);
  };

  const handleChange = (event) => {
    setCategoryId(event.target.value);
  };

  const handleProductTypeChange = (event) => {
    setProductType(event.target.value);
  };

  const handleProductEnableChange = (event) => {
    setIsPlayable(event.target.value);
  };

  const handleTimeBasedEventChange = (event) => {
    setIsTimeBasedEvent(event.target.value);
  };

  

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
    if (e.target.files && e.target.files[0]) {
      setImageName(e.target.files[0].name);
    }
  };

  const handleDelete = (id) => {
    setSelectedProductId(id);
    setOpen(true);
  };

  const handleClone = (id) => {
    setCloneProductId(id);
    setCloneDialogOpen(true);
  };

  const confirmClone = async () => {
    if (!cloneProductId) return;
    try {
      await cloneProduct(cloneProductId).unwrap();
      toast.success('Product cloned successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      refetch();
    } catch (error) {
      console.error("Error cloning product:", error);
      toast.error('Failed to clone product', {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
      });
    }
    setCloneDialogOpen(false);
    setCloneProductId(null);
  };

  const handleCloneClose = () => {
    setCloneDialogOpen(false);
    setCloneProductId(null);
  };

  const handleProductWishesOpen = (product) => {
    setProductForWishes({
      _id: product._id,
      productName: product.productName,
    });
    setProductWishSidebarOpen(true);
  };

  const handleProductWishesClose = () => {
    setProductWishSidebarOpen(false);
    setProductForWishes(null);
  };

  const renderProductActions = (product, { mobile = false } = {}) => {
    const { _id, productName, productPrice, totalWish, totalQuestions, isFirstWinnerGotProduct } = product;

    return (
      <div className={`flex items-center ${mobile ? "flex-wrap gap-2" : "justify-end gap-1"}`}>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleEdit(_id)}
          className={`border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 h-8 px-2 ${mobile ? "flex-1" : ""}`}
        >
          <Edit className="h-3 w-3 mr-1" />
          Edit
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleDelete(_id)}
          className={`border-red-300 dark:border-red-600 text-red-700 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 h-8 px-2 ${mobile ? "flex-1" : ""}`}
        >
          <Trash2 className="h-3 w-3 mr-1" />
          Delete
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleClone(_id)}
          disabled={LoadingClone}
          className={`border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 h-8 px-2 ${mobile ? "flex-1" : ""}`}
        >
          <Copy className="h-3 w-3 mr-1" />
          Clone
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              className={`border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 h-8 px-2 ${mobile ? "flex-1" : ""}`}
            >
              <MoreHorizontal className="h-3 w-3 mr-1" />
              More
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
            <DropdownMenuItem
              onClick={() => handleProductWishesOpen({ _id, productName })}
              className="cursor-pointer"
            >
              <ListOrdered className="h-4 w-4 mr-2" />
              Competition Rounds
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => handleImageDialogOpen(_id)}
              className="cursor-pointer"
            >
              <Image className="h-4 w-4 mr-2" />
              Images
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => handleQuestionDialogOpen(_id, totalQuestions)}
              className="cursor-pointer"
            >
              <HelpCircle className="h-4 w-4 mr-2" />
              Questions
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => handleWishDialogOpen(_id, productPrice, totalWish, isFirstWinnerGotProduct)}
              className="cursor-pointer"
            >
              <Trophy className="h-4 w-4 mr-2" />
              Winnings
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => handleComboDialogOpen(_id)}
              className="cursor-pointer"
            >
              <Layers className="h-4 w-4 mr-2" />
              Combo Winnings
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  };

  const confirmDelete = async () => {
    try {
      await deleteProduct(selectedProductId);
      toast.success('Product Deleted!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error) {
      console.error("Error deleting product:", error);
    }
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const handleCreateDialogOpen = () => {
    setOpenCreateDialog(true);
  };
  const handleCreateDialogClose = () => {
    setOpenCreateDialog(false);
  };

  const handleCreateProduct = async () => {
    try {
      await createProduct({
        productName,
        productDescription,
        terms,
        categoryId,
        productPrice,
        totalWish,
        totalQuestions,
        status,
        image: selectedImage,
        deductingWish,
        productType,
        isFirstWinnerGotProduct,
        isPlayable,
        isTimeBasedEvent,
        isHomeFeatured,
        startDateTime,
        endDateTime,
      });
      console.log("Product created successfully!");
    } catch (error) {
      console.error("Error creating product:", error);
    }
    refetch();
    setOpenCreateDialog(false);
  };

  const handleEdit = (id) => {
    const product = data.find(prod => prod._id === id);
    if (product) {
      setEditingProduct(product);
      setProductName(product.productName);
      setProductDescription(product.productDescription);
      setTerms(product.terms);
      setCategoryId(product.categoryId);
      setProductPrice(product.productPrice);
      setTotalWish(product.totalWish);
      setTotalQuestions(product.totalQuestions);
      setDeductingWish(product.deductingWish);
      setStatus(product.status === 'ACTIVE');
      setProductType(product.productType);
      setIsFirstWinnerGotProduct(product.isFirstWinnerGotProduct);
      setDeductingWish(product.deductingWish);
      setImageName(product.image);
      setIsPlayable(product.isPlayable);
      setIsTimeBasedEvent(product.isTimeBasedEvent === true ? "1" : "0");
      setIsHomeFeatured(product.isHomeFeatured === true);
      setStartDateTime(convertToISTSimple(product.startDateTime));
      setEndDateTime(convertToISTSimple(product.endDateTime));
      setEditDialogOpen(true);
      
    }
  };

  function convertToISTSimple(input) {
    // Parse the input UTC date
    const utcDate = new Date(input);
  
    // IST offset: UTC + 5 hours 30 minutes
    const IST_OFFSET = 5.5 * 60 * 60 * 1000; // Convert hours to milliseconds
  
    // Convert to IST
    const istDate = new Date(utcDate.getTime() + IST_OFFSET);
  
    // Format as `YYYY-MM-DDTHH:mm`
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, "0");
    const day = String(istDate.getDate()).padStart(2, "0");
    const hours = String(istDate.getHours()).padStart(2, "0");
    const minutes = String(istDate.getMinutes()).padStart(2, "0");
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const handleEditClose = () => {
    setEditDialogOpen(false);
    setEditingProduct(null);
    setProductName("");
    setProductDescription("");
    setTerms("");
    setCategoryId("");
    setProductPrice("");
    setTotalWish("");
    setTotalQuestions("");
    setIsPlayable("");
    setStatus(false);
    setIsFirstWinnerGotProduct("");
    setSelectedImage(null);
    setImageName("");
    setIsTimeBasedEvent("");
    setIsHomeFeatured(false);
  };

  const handleUpdateProduct = async () => {
    try {
      await updateProduct({
        _id: editingProduct._id,
        productName,
        productDescription,
        terms,
        categoryId,
        productPrice,
        totalWish,
        totalQuestions,
        status: status ? 'ACTIVE' : 'INACTIVE',
        image: selectedImage || editingProduct.image,
        productType,
        deductingWish,
        isFirstWinnerGotProduct : isFirstWinnerGotProduct,
        isPlayable,
        isTimeBasedEvent,
        isHomeFeatured,
        startDateTime,
        endDateTime,
      });
      console.log("Product updated successfully!");
      handleEditClose();
      refetch();
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const handleHomeFeaturedToggle = async (product, enabled) => {
    if (featuredToggleId) return;
    try {
      setFeaturedToggleId(product._id);
      const categoryId =
        product.categoryId?._id || product.categoryId || product.category?._id;
      await updateProduct({
        _id: product._id,
        productName: product.productName,
        productDescription: product.productDescription,
        terms: product.terms,
        categoryId,
        productPrice: product.productPrice,
        totalWish: product.totalWish,
        totalQuestions: product.totalQuestions,
        status: product.status,
        image: product.image,
        productType: product.productType,
        deductingWish: product.deductingWish,
        isFirstWinnerGotProduct: product.isFirstWinnerGotProduct,
        isPlayable: product.isPlayable,
        isTimeBasedEvent: product.isTimeBasedEvent === true ? "1" : "0",
        isHomeFeatured: enabled,
        startDateTime: product.startDateTime,
        endDateTime: product.endDateTime,
      }).unwrap();
      toast.success(
        enabled
          ? `"${product.productName}" is now the home featured product`
          : "Home featured removed"
      );
      refetch();
    } catch (error) {
      console.error("Error toggling home featured:", error);
      toast.error("Failed to update home featured");
    } finally {
      setFeaturedToggleId(null);
    }
  };

  const renderHomeFeaturedToggle = (product) => {
    const isFeatured = product.isHomeFeatured === true;
    const isBusy = featuredToggleId === product._id;
    return (
      <div className="flex flex-col gap-1 min-w-[120px]">
        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500 disabled:opacity-50"
            checked={isFeatured}
            disabled={isBusy || featuredToggleId !== null}
            onChange={(e) => handleHomeFeaturedToggle(product, e.target.checked)}
          />
          {isBusy ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin text-amber-600" />
          ) : (
            <span
              className={`text-xs font-semibold ${
                isFeatured
                  ? "text-amber-700 dark:text-amber-400"
                  : "text-gray-500 dark:text-gray-400"
              }`}
            >
              {isFeatured ? "Featured" : "Off"}
            </span>
          )}
        </label>
        <span className="text-[10px] leading-tight text-gray-400 dark:text-gray-500">
          Full-width app hero · one only
        </span>
      </div>
    );
  };

  const calculateTotalPercentage = () => {
    return wishRanges.reduce((total, wish) => total + parseFloat(wish.percentage || 0), 0);
  };

  const calculatePendingAmount = () => {
    const totalAllocatedAmount = wishRanges.reduce((total, wish) => total + parseFloat(wish.amount || 0), 0);
    return productPrice - totalAllocatedAmount;
  };

  // Pagination calculations
  const totalItems = data?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentProducts = data?.slice(startIndex, endIndex) || [];
  
  // Debug: Log pagination data
  console.log("Total items:", totalItems);
  console.log("Current page:", currentPage);
  console.log("Start index:", startIndex);
  console.log("End index:", endIndex);
  console.log("Current products:", currentProducts);
  console.log("Current products length:", currentProducts?.length);

  // Pagination handlers
  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const goToFirstPage = () => {
    setCurrentPage(1);
  };

  const goToLastPage = () => {
    setCurrentPage(totalPages);
  };

  const goToPreviousPage = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
  };

  const goToNextPage = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <ToastContainer position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      
      {/* Header Section */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Product Management</h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Manage and organize products across your platform
              </p>
            </div>
            <Button 
              onClick={handleCreateDialogOpen}
              className="bg-gray-900 hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100"
            >
              <Plus className="h-4 w-4 mr-2" />
              Create Product
            </Button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <Card className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Products</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">{totalItems}</p>
                </div>
                <div className="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center">
                  <Plus className="w-5 h-5 text-gray-600 dark:text-gray-400" />
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Active Products</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">
                    {data?.filter(p => p.isPlayable === "YES").length || 0}
                  </p>
                </div>
                <div className="w-10 h-10 bg-green-100 dark:bg-green-900/20 rounded-lg flex items-center justify-center">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Free Entry</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">
                    {data?.filter(p => p.productType === "FREE_ENTRY").length || 0}
                  </p>
                </div>
                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400">This Page</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">{currentProducts.length}</p>
                </div>
                <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900/20 rounded-lg flex items-center justify-center">
                  <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Main Table Card */}
        <Card className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 shadow-sm">
          <CardHeader className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
            <div className="flex items-center justify-between">
              <div>
                <CardTitle className="text-lg font-semibold text-gray-900 dark:text-white">Product List</CardTitle>
                <CardDescription className="text-sm text-gray-600 dark:text-gray-400">
                  Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} products
                </CardDescription>
              </div>
              <div className="flex items-center space-x-2">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    placeholder="Search products..."
                    className="pl-10 w-64 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600"
                  />
                </div>
                <Button variant="outline" size="sm" className="border-gray-300 dark:border-gray-600">
                  <Filter className="h-4 w-4 mr-2" />
                  Filter
                </Button>
              </div>
            </div>
          </CardHeader>
          
          <CardContent className="p-0">
            {isLoading ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-gray-600 dark:text-gray-400" />
                <span className="ml-3 text-gray-600 dark:text-gray-400">Loading products...</span>
              </div>
            ) : !data || data.length === 0 ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Plus className="w-8 h-8 text-gray-400" />
                </div>
                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No products found</h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  {productsResponse ? `API returned: ${JSON.stringify(productsResponse).substring(0, 200)}...` : 'No data from API'}
                </p>
                <Button 
                  onClick={handleCreateDialogOpen}
                  className="bg-gray-900 hover:bg-gray-800 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100"
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Create Product
                </Button>
              </div>
            ) : (
              <div>
                {/* Desktop Table */}
                <div className="overflow-x-auto">
                  <Table className="hidden lg:table">
                    <TableHeader>
                      <TableRow className="bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-50 dark:hover:bg-gray-800/50">
                        <TableHead className="font-semibold text-gray-900 dark:text-white">Sr.No</TableHead>
                        <TableHead className="font-semibold text-gray-900 dark:text-white">Product Name</TableHead>
                        <TableHead className="font-semibold text-gray-900 dark:text-white">Status</TableHead>
                        <TableHead className="font-semibold text-gray-900 dark:text-white min-w-[140px]">
                          <div className="flex flex-col">
                            <span>Home Featured</span>
                            <span className="text-[10px] font-normal text-gray-500">
                              One product at a time
                            </span>
                          </div>
                        </TableHead>
                        <TableHead className="font-semibold text-gray-900 dark:text-white">Category</TableHead>
                        <TableHead className="font-semibold text-gray-900 dark:text-white">Description</TableHead>
                        <TableHead className="font-semibold text-gray-900 dark:text-white text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {console.log("Rendering table with currentProducts:", currentProducts)}
                      {currentProducts.map((product, index) => {
                        const { _id, productName, productDescription, category, productType, isPlayable, isHomeFeatured } = product;
                        console.log("Rendering product:", { _id, productName, productType, isPlayable });
                        return (
                        <TableRow 
                          key={_id} 
                          className={`border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 ${
                            isPlayable === "YES" ? 'bg-green-50/50 dark:bg-green-900/10' : 'bg-red-50/50 dark:bg-red-900/10'
                          } ${isHomeFeatured ? 'ring-1 ring-inset ring-amber-200 dark:ring-amber-800/50' : ''}`}
                        >
                          <TableCell className="py-2 text-sm text-gray-900 dark:text-white">{startIndex + index + 1}</TableCell>
                          <TableCell className="py-2">
                            <div>
                              <p className="font-medium text-gray-900 dark:text-white text-sm">
                                {productName}
                                {isHomeFeatured && (
                                  <span className="ml-2 inline-block bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-300 px-2 py-0.5 rounded text-xs font-semibold">
                                    Home Featured
                                  </span>
                                )}
                              </p>
                              <div className="mt-1">
                                {productType === "FREE_ENTRY" ? (
                                  <span className="inline-block bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 px-2 py-1 rounded text-xs">
                                    FREE ENTRY
                                  </span>
                                ) : (
                                  <span className="inline-block bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400 px-2 py-1 rounded text-xs">
                                    PAID ENTRY
                                  </span>
                                )}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="py-2">
                            {isPlayable === "YES" ? (
                              <span className="inline-block bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400 px-2 py-1 rounded text-xs">
                                ACTIVE
                              </span>
                            ) : (
                              <span className="inline-block bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 px-2 py-1 rounded text-xs">
                                DISABLED
                              </span>
                            )}
                          </TableCell>
                          <TableCell className="py-2 align-top">
                            {renderHomeFeaturedToggle(product)}
                          </TableCell>
                          <TableCell className="py-2 text-sm text-gray-900 dark:text-white">{category?.name || 'N/A'}</TableCell>
                          <TableCell className="py-2">
                            <p className="text-sm text-gray-900 dark:text-white">
                              {productDescription?.length > 50
                                ? `${productDescription.substring(0, 50)}...`
                                : productDescription || 'N/A'}
                            </p>
                          </TableCell>
                          <TableCell className="py-2 text-right">
                            {renderProductActions(product)}
                          </TableCell>
                         </TableRow>
                       );
                       })}
                     </TableBody>
                  </Table>
                </div>

                {/* Mobile Cards */}
                <div className="lg:hidden space-y-4 p-4">
                  {currentProducts.map((product) => {
                    const {
                      _id,
                      productName,
                      productDescription,
                      category,
                      productType,
                      isPlayable,
                      isHomeFeatured,
                      productPrice,
                      totalWish,
                      totalQuestions,
                    } = product;
                    return (
                    <Card key={_id} className={`bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 ${
                      isPlayable === "YES" ? 'border-l-4 border-l-green-500' : 'border-l-4 border-l-red-500'
                    } ${isHomeFeatured ? 'ring-1 ring-amber-200 dark:ring-amber-800/50' : ''}`}>
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between mb-3">
                          <div>
                            <h3 className="font-medium text-gray-900 dark:text-white">
                              {productName}
                              {isHomeFeatured && (
                                <span className="ml-2 inline-block bg-amber-100 text-amber-800 px-2 py-0.5 rounded text-xs">
                                  Featured
                                </span>
                              )}
                            </h3>
                            <p className="text-sm text-gray-500 dark:text-gray-400">ID: {_id}</p>
                          </div>
                          <div className="flex flex-col items-end space-y-1">
                            {productType === "FREE_ENTRY" ? (
                              <span className="inline-block bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 px-2 py-1 rounded text-xs">
                                FREE ENTRY
                              </span>
                            ) : (
                              <span className="inline-block bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400 px-2 py-1 rounded text-xs">
                                PAID ENTRY
                              </span>
                            )}
                            {isPlayable === "YES" ? (
                              <span className="inline-block bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400 px-2 py-1 rounded text-xs">
                                ACTIVE
                              </span>
                            ) : (
                              <span className="inline-block bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 px-2 py-1 rounded text-xs">
                                DISABLED
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="space-y-2 mb-3">
                          <div className="text-sm text-gray-500 dark:text-gray-400">
                            Category: {category?.name || 'N/A'}
                          </div>
                          <div className="text-sm text-gray-500 dark:text-gray-400">
                            Description: {productDescription?.length > 50
                              ? `${productDescription.substring(0, 50)}...`
                              : productDescription || 'N/A'}
                          </div>
                          <div className="text-sm text-gray-500 dark:text-gray-400">
                            Price: ₹{productPrice || 'N/A'}
                          </div>
                          <div className="text-sm text-gray-500 dark:text-gray-400">
                            Total Wish: {totalWish || 'N/A'}
                          </div>
                          <div className="text-sm text-gray-500 dark:text-gray-400">
                            Questions: {totalQuestions || 'N/A'}
                          </div>
                        </div>
                        <div className="mb-3 rounded-lg border border-amber-100 bg-amber-50/60 dark:bg-amber-900/10 dark:border-amber-900/30 p-3">
                          {renderHomeFeaturedToggle(product)}
                        </div>
                        {renderProductActions(product, { mobile: true })}
                      </CardContent>
                    </Card>
                    );
                  })}
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                    <div className="flex items-center space-x-2 text-sm text-gray-700 dark:text-gray-300">
                      <span>
                        Showing {startIndex + 1} to {Math.min(endIndex, totalItems)} of {totalItems} results
                      </span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={goToFirstPage}
                        disabled={currentPage === 1}
                        className="border-gray-300 dark:border-gray-600"
                      >
                        <ChevronsLeft className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                        className="border-gray-300 dark:border-gray-600"
                      >
                        <ChevronLeft className="h-4 w-4" />
                      </Button>
                      
                      {/* Page Numbers */}
                      <div className="flex items-center space-x-1">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNum;
                          if (totalPages <= 5) {
                            pageNum = i + 1;
                          } else if (currentPage <= 3) {
                            pageNum = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNum = totalPages - 4 + i;
                          } else {
                            pageNum = currentPage - 2 + i;
                          }
                          
                          return (
                            <Button
                              key={pageNum}
                              variant={currentPage === pageNum ? "default" : "outline"}
                              size="sm"
                              onClick={() => goToPage(pageNum)}
                              className={`w-8 h-8 p-0 ${
                                currentPage === pageNum 
                                  ? "bg-gray-900 text-white dark:bg-white dark:text-gray-900" 
                                  : "border-gray-300 dark:border-gray-600"
                              }`}
                            >
                              {pageNum}
                            </Button>
                          );
                        })}
                      </div>
                      
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        className="border-gray-300 dark:border-gray-600"
                      >
                        <ChevronRight className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={goToLastPage}
                        disabled={currentPage === totalPages}
                        className="border-gray-300 dark:border-gray-600"
                      >
                        <ChevronsRight className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </CardContent>
        </Card>
      </div>

      {/* Dialogs */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogDescription>
              Are you sure you want to delete this product?
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            <Button onClick={confirmDelete} disabled={LoadingDelete}>
              {LoadingDelete ? "Deleting..." : "Confirm"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog
        open={cloneDialogOpen}
        onOpenChange={(isOpen) => {
          setCloneDialogOpen(isOpen);
          if (!isOpen) setCloneProductId(null);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Confirm Clone</DialogTitle>
            <DialogDescription>
              Are you sure you want to clone this product? A copy will be created with a new play token, images, questions, and winnings.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={handleCloneClose}>
              Cancel
            </Button>
            <Button onClick={confirmClone} disabled={LoadingClone}>
              {LoadingClone ? "Cloning..." : "Confirm"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={openCreateDialog} onOpenChange={setOpenCreateDialog}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Create Product</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium mb-2">Please Select Entry Type</h3>
              <Select value={productType} onValueChange={setProductType}>
                <SelectTrigger>
                  <SelectValue placeholder="Select Product Entry Type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="FREE_ENTRY">Free Entry</SelectItem>
                  <SelectItem value="PAID_ENTRY">Paid Entry</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <h3 className="font-medium mb-2">Legacy default (rank 1 only)</h3>
              <p className="text-xs text-muted-foreground mb-2">
                Used only when a winning row has no prize type. Prefer setting CASH/PRODUCT per rank in Winning Management.
              </p>
              <Select value={isFirstWinnerGotProduct} onValueChange={setIsFirstWinnerGotProduct}>
                <SelectTrigger>
                  <SelectValue placeholder="Select Cash or Product for rank 1 fallback" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="CASH">CASH</SelectItem>
                  <SelectItem value="PRODUCT">PRODUCT</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <h3 className="font-medium mb-2">Enable for Playing?</h3>
              <Select value={isPlayable} onValueChange={setIsPlayable}>
                <SelectTrigger>
                  <SelectValue placeholder="Select Enable for playing" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="YES">YES</SelectItem>
                  <SelectItem value="NO">NO</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <h3 className="font-medium mb-2">Is Time Based Event?</h3>
              <Select value={isTimeBasedEvent} onValueChange={setIsTimeBasedEvent}>
                <SelectTrigger>
                  <SelectValue placeholder="Is Time Based Event" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="1">YES</SelectItem>
                  <SelectItem value="0">NO</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="rounded-lg border border-amber-200 bg-amber-50/80 p-3">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <h3 className="font-medium">Home Featured</h3>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Full-width hero on app home (only one product at a time)
                  </p>
                </div>
                <Select
                  value={isHomeFeatured ? "YES" : "NO"}
                  onValueChange={(value) => setIsHomeFeatured(value === "YES")}
                >
                  <SelectTrigger className="w-24">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="YES">YES</SelectItem>
                    <SelectItem value="NO">NO</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div>
              <h3 className="font-medium mb-2">Start Date time</h3>
              <Input
                type="datetime-local"
                value={startDateTime}
                onChange={(e) => setStartDateTime(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">End Date time</h3>
              <Input
                type="datetime-local"
                value={endDateTime}
                onChange={(e) => setEndDateTime(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Product Name</h3>
              <Input
                placeholder="Product Name"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              />
            </div>

            {categoryData || !categoryLoading ? (
              <div>
                <h3 className="font-medium mb-2">Category</h3>
                <Select value={categoryId} onValueChange={setCategoryId}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select Category" />
                  </SelectTrigger>
                  <SelectContent>
                    {categoryData.map(({ _id, name }) => (
                      <SelectItem key={_id} value={_id}>
                        {name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            ) : (
              <div className="text-center">
                <h5 className="text-xl">Loading...</h5>
              </div>
            )}

            <div>
              <h3 className="font-medium mb-2">Product Description</h3>
              <textarea
                className="w-full p-2 border rounded-md"
                rows={4}
                placeholder="Product Description"
                value={productDescription}
                onChange={(e) => setProductDescription(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Terms</h3>
              <textarea
                className="w-full p-2 border rounded-md"
                rows={4}
                placeholder="Terms"
                value={terms}
                onChange={(e) => setTerms(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Product Price Pool</h3>
              <Input
                type="number"
                placeholder="Product Price Pool"
                value={productPrice}
                onChange={(e) => setProductPrice(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Total Wish</h3>
              <Input
                type="number"
                placeholder="Total Wish"
                value={totalWish}
                onChange={(e) => setTotalWish(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Deducting number of Wish</h3>
              <Input
                type="number"
                placeholder="Deducting number of Wish"
                value={deductingWish}
                onChange={(e) => setDeductingWish(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Total Questions</h3>
              <Input
                type="number"
                placeholder="Total Questions"
                value={totalQuestions}
                onChange={(e) => setTotalQuestions(e.target.value)}
              />
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="status"
                checked={status}
                onChange={(e) => setStatus(e.target.checked)}
                className="rounded"
              />
              <label htmlFor="status">Status</label>
            </div>

            <div>
              <input
                accept="image/*"
                id="image"
                type="file"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              <label htmlFor="image">
                <Button variant="outline" className="text-green-600 border-green-600 hover:bg-green-50">
                  <Upload className="h-4 w-4 mr-2" />
                  Select Image
                </Button>
              </label>
              {imageName && <p className="text-sm text-gray-600 mt-1">{imageName}</p>}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={handleCreateDialogClose}>
              Cancel
            </Button>
            <Button onClick={handleCreateProduct} disabled={LoadingCreate}>
              {LoadingCreate ? "Creating..." : "Create"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {editDialogOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40"
            onClick={handleEditClose}
            aria-hidden="true"
          />
          <aside
            className="fixed top-0 right-0 z-50 h-full w-[70%] bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 shadow-2xl flex flex-col"
            role="dialog"
            aria-label="Edit Product"
          >
            <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
              <div className="min-w-0">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Edit Product
                </h2>
                {editingProduct?._id && (
                  <p className="text-sm text-muted-foreground mt-1">
                    Product ID:{" "}
                    <span className="font-mono text-xs select-all">
                      {editingProduct._id}
                    </span>
                  </p>
                )}
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="shrink-0 h-8 w-8 p-0"
                onClick={handleEditClose}
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>

            <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
            <div>
              <h3 className="font-medium mb-2">Please Select Entry Type</h3>
              <Select value={productType} onValueChange={setProductType}>
                <SelectTrigger>
                  <SelectValue placeholder="Select Product Type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="FREE_ENTRY">Free Entry</SelectItem>
                  <SelectItem value="PAID_ENTRY">Paid Entry</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <h3 className="font-medium mb-2">Legacy default (rank 1 only)</h3>
              <p className="text-xs text-muted-foreground mb-2">
                Used only when a winning row has no prize type. Prefer setting CASH/PRODUCT per rank in Winning Management.
              </p>
              <Select value={isFirstWinnerGotProduct} onValueChange={setIsFirstWinnerGotProduct}>
                <SelectTrigger>
                  <SelectValue placeholder="Select Cash or Product for rank 1 fallback" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="CASH">CASH</SelectItem>
                  <SelectItem value="PRODUCT">PRODUCT</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <h3 className="font-medium mb-2">Enable for Playing?</h3>
              <Select value={isPlayable} onValueChange={setIsPlayable}>
                <SelectTrigger>
                  <SelectValue placeholder="Select Enable for playing" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="YES">YES</SelectItem>
                  <SelectItem value="NO">NO</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <h3 className="font-medium mb-2">Is Time Based Event?</h3>
              <Select value={isTimeBasedEvent} onValueChange={setIsTimeBasedEvent}>
                <SelectTrigger>
                  <SelectValue placeholder="Is Time Based Event" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="1">YES</SelectItem>
                  <SelectItem value="0">NO</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="rounded-lg border border-amber-200 bg-amber-50/80 p-3">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <h3 className="font-medium">Home Featured</h3>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Full-width hero on app home (only one product at a time)
                  </p>
                </div>
                <Select
                  value={isHomeFeatured ? "YES" : "NO"}
                  onValueChange={(value) => setIsHomeFeatured(value === "YES")}
                >
                  <SelectTrigger className="w-24">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="YES">YES</SelectItem>
                    <SelectItem value="NO">NO</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div>
              <h3 className="font-medium mb-2">Start Date time</h3>
              <Input
                type="datetime-local"
                value={startDateTime}
                onChange={(e) => setStartDateTime(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">End Date time</h3>
              <Input
                type="datetime-local"
                value={endDateTime}
                onChange={(e) => setEndDateTime(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Product Name</h3>
              <Input
                placeholder="Product Name"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Product Description</h3>
              <textarea
                className="w-full p-2 border rounded-md"
                rows={4}
                placeholder="Product Description"
                value={productDescription}
                onChange={(e) => setProductDescription(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Terms</h3>
              <textarea
                className="w-full p-2 border rounded-md"
                rows={4}
                placeholder="Terms"
                value={terms}
                onChange={(e) => setTerms(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Category ID</h3>
              <Input
                placeholder="Category ID"
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Product Price Pool</h3>
              <Input
                type="number"
                placeholder="Product Price Pool"
                value={productPrice}
                onChange={(e) => setProductPrice(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Total Wish</h3>
              <Input
                type="number"
                placeholder="Total Wish"
                value={totalWish}
                onChange={(e) => setTotalWish(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Total Questions</h3>
              <Input
                type="number"
                placeholder="Total Questions"
                value={totalQuestions}
                onChange={(e) => setTotalQuestions(e.target.value)}
              />
            </div>

            <div>
              <h3 className="font-medium mb-2">Deducting number of Wish</h3>
              <Input
                type="number"
                placeholder="Deducting number of Wish"
                value={deductingWish}
                onChange={(e) => setDeductingWish(e.target.value)}
              />
            </div>

            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="edit-status"
                checked={status}
                onChange={(e) => setStatus(e.target.checked)}
                className="rounded"
              />
              <label htmlFor="edit-status">Status</label>
            </div>
            </div>

            <div className="shrink-0 flex items-center justify-end gap-2 px-5 py-4 border-t border-gray-200 dark:border-gray-700">
              <Button variant="outline" onClick={handleEditClose}>
                Cancel
              </Button>
              <Button onClick={handleUpdateProduct} disabled={LoadingUpdate}>
                {LoadingUpdate ? "Updating..." : "Update"}
              </Button>
            </div>
          </aside>
        </>
      )}

      {questionDialogOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40"
            onClick={handleQuestionDialogClose}
            aria-hidden="true"
          />
          <aside
            className="fixed top-0 right-0 z-50 h-full w-[70%] bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 shadow-2xl flex flex-col"
            role="dialog"
            aria-label="Question Management"
          >
            <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                Question Management
              </h2>
              <Button
                variant="ghost"
                size="sm"
                className="shrink-0 h-8 w-8 p-0"
                onClick={handleQuestionDialogClose}
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>

            <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
            {productAllQuestions !== null && productAllQuestions.map((question, index) => (
              <div key={index} className="flex items-center justify-between p-2 border rounded">
                <p className="flex-1">
                  (Type: {question.questionFormat}) (Question: {question.questionCount})
                </p>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleDeleteQuestion(question._id)}
                  className="text-red-600 hover:bg-red-50"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))}

            {questionTypes.map((questionType, index) => (
              <div key={index} className="flex items-center gap-2">
                <Select
                  value={questionType.type}
                  onValueChange={(value) => handleQuestionTypeChange(index, 'type', value)}
                >
                  <SelectTrigger className="w-48">
                    <SelectValue placeholder="Question Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="a+b">a+b</SelectItem>
                    <SelectItem value="aa+b">aa+b</SelectItem>
                    <SelectItem value="a-b">a-b</SelectItem>
                    <SelectItem value="aa-b">aa-b</SelectItem>
                    <SelectItem value="a*b">a*b</SelectItem>
                    <SelectItem value="aa*b">aa*b</SelectItem>
                    <SelectItem value="a/b">a/b</SelectItem>
                    <SelectItem value="aa/b">aa/b</SelectItem>
                    <SelectItem value="a%b">a%b</SelectItem>
                    <SelectItem value="aa%b">aa%b</SelectItem>
                  </SelectContent>
                </Select>
                <Input
                  className="w-48"
                  placeholder="Number of Questions"
                  value={questionType.count}
                  onChange={(e) => handleQuestionTypeChange(index, 'count', e.target.value)}
                />
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleRemoveQuestionType(index)}
                  className="text-red-600 hover:bg-red-50"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))}
            <Button onClick={handleAddQuestionType} className="bg-green-600 hover:bg-green-700">
              <Plus className="h-4 w-4 mr-2" />
              Add Questions
            </Button>

            <div className="flex justify-between items-center">
              <p className="text-sm text-gray-600">
                Note: You can Update Total Qty of Question in Edit Product
              </p>
              <p className="font-medium">
                Total Questions: {productQuestionCount}
              </p>
            </div>
            </div>

            <div className="shrink-0 flex items-center justify-end gap-2 px-5 py-4 border-t border-gray-200 dark:border-gray-700">
              <Button onClick={handleUpdateQuestion} className="bg-yellow-600 hover:bg-yellow-700">
                <Plus className="h-4 w-4 mr-2" />
                Update Questions
              </Button>
              <Button variant="outline" onClick={handleQuestionDialogClose}>
                Close
              </Button>
            </div>
          </aside>
        </>
      )}

      {wishDialogOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40"
            onClick={handleWishDialogClose}
            aria-hidden="true"
          />
          <aside
            className="fixed top-0 right-0 z-50 h-full w-[70%] bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 shadow-2xl flex flex-col"
            role="dialog"
            aria-label="Winning Management"
          >
            <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                Winning Management
              </h2>
              <Button
                variant="ghost"
                size="sm"
                className="shrink-0 h-8 w-8 p-0"
                onClick={handleWishDialogClose}
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>

            <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
            <div className="text-right space-y-1">
              <p className="font-medium">Set rank or range (e.g. 1, 3, 2-10) and prize type per row</p>
              <p className="font-medium">Product Distribute Price: ₹ {productPrice}</p>
              <p className="font-medium">Total Wish Count: {totalWishCount}</p>
            </div>
            <Separator />
            
            <div>
              <h3 className="font-medium mb-2">Range for this Product</h3>
              <p className="text-xs text-muted-foreground mb-2">
                Change CASH / PRODUCT on an existing row to save it. Rows showing legacy use the product&apos;s rank-1 fallback until you pick a type.
              </p>
            </div>
            
            {productAllWinning !== null && productAllWinning.map((question, index) => (
              <div key={question._id || index} className="flex flex-wrap items-center justify-between gap-2 p-2 border rounded">
                <p className="flex-1 min-w-[200px]">
                  (Range: {question.winrange}) (Percent: {question.winpercent}%) (Amount: ₹{question.amount})
                </p>
                <Select
                  value={resolveExistingPrizeType(question)}
                  onValueChange={(value) =>
                    handleUpdateExistingWinningPrizeType(question._id, value)
                  }
                >
                  <SelectTrigger className="w-32">
                    <SelectValue placeholder="Prize type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="CASH">CASH</SelectItem>
                    <SelectItem value="PRODUCT">PRODUCT</SelectItem>
                  </SelectContent>
                </Select>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleDeleteProductWinning(question._id)}
                  className="text-red-600 hover:bg-red-50"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))}

            <div className="flex justify-between items-center">
              <p className="font-medium">
                Total Percent: {productAllWinning.reduce((total, question) => total + parseFloat(question.winpercent), 0)}%
              </p>
              <p className="font-medium">
                Total Amount: ₹{productAllWinning.reduce((total, question) => total + parseFloat(question.amount), 0).toFixed(2)}
              </p>
            </div>

            <Separator />

            {wishRanges.map((wishRange, index) => (
              <div key={index} className="flex flex-wrap items-center gap-2">
                <Input
                  className="w-28"
                  placeholder="Rank e.g. 1 or 2-5"
                  value={wishRange.range}
                  onChange={(e) => handleWishRangeChange(index, 'range', e.target.value)}
                />
                <Input
                  className="w-24"
                  placeholder="%"
                  value={wishRange.percentage}
                  onChange={(e) => handleWishRangeChange(index, 'percentage', e.target.value)}
                />
                <p className="w-20 font-medium text-sm">₹ {wishRange.amount}</p>
                <Select
                  value={wishRange.prizeType || "CASH"}
                  onValueChange={(value) => handleWishRangeChange(index, 'prizeType', value)}
                >
                  <SelectTrigger className="w-32">
                    <SelectValue placeholder="Prize type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="CASH">CASH</SelectItem>
                    <SelectItem value="PRODUCT">PRODUCT</SelectItem>
                  </SelectContent>
                </Select>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => handleRemoveWishRange(index)}
                  className="text-red-600 hover:bg-red-50"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            ))}
            
            <div className="flex justify-between items-center">
              <Button onClick={handleAddWishRange} className="bg-green-600 hover:bg-green-700">
                <Plus className="h-4 w-4 mr-2" />
                Add Winning Range
              </Button>
              <p className="font-medium">
                Total Percentage: {calculateTotalPercentage()}%
              </p>
            </div>
            
            <p className="text-right font-medium">
              Pending Amount: ₹ {calculatePendingAmount()}
            </p>
            </div>

            <div className="shrink-0 flex items-center justify-end gap-2 px-5 py-4 border-t border-gray-200 dark:border-gray-700">
              <Button onClick={handleUpdateWish} className="bg-green-600 hover:bg-green-700">
                <Plus className="h-4 w-4 mr-2" />
                Update Winning
              </Button>
              <Button variant="outline" onClick={handleWishDialogClose}>
                Close
              </Button>
            </div>
          </aside>
        </>
      )}

      {comboDialogOpen && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/40"
            onClick={handleComboDialogClose}
            aria-hidden="true"
          />
          <aside
            className="fixed top-0 right-0 z-50 h-full w-[70%] bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700 shadow-2xl flex flex-col"
            role="dialog"
            aria-label="Combo Winning Management"
          >
            <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
              <div className="min-w-0">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Combo Winning Management
                </h2>
                <p className="text-sm text-muted-foreground mt-1">
                  Separate from regular rank winnings. User must hit all listed ranks (across attempts) in the same round.
                  Each combo can be CASH or a different product — use a unique product name per combo.
                </p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="shrink-0 h-8 w-8 p-0"
                onClick={handleComboDialogClose}
                aria-label="Close"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>

            <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
            <div>
              <h3 className="font-medium mb-2">Existing combo prizes</h3>
              {productAllComboWinning.length === 0 ? (
                <p className="text-sm text-muted-foreground">No combo winnings yet.</p>
              ) : (
                productAllComboWinning.map((combo) => {
                  const edit = comboEdits[combo._id] || {
                    prizeType: combo.prizeType || 'CASH',
                    label: combo.label || '',
                    amount: combo.amount || '',
                  };
                  const isProductPrize = edit.prizeType === 'PRODUCT';

                  return (
                  <div key={combo._id} className="flex flex-wrap items-center justify-between gap-2 p-2 border rounded mb-2">
                    <div className="flex-1 min-w-[200px]">
                      <p className="font-medium text-sm">
                        Ranks: {combo.comboRanks.split(',').map((r) => `#${r.trim()}`).join(' + ')}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        Saved: {isProductPrize
                          ? combo.label || 'Product name not set'
                          : `₹${combo.amount}${combo.label ? ` · ${combo.label}` : ''}`}
                      </p>
                    </div>
                    <Select
                      value={edit.prizeType}
                      onValueChange={(value) => handleComboEditChange(combo._id, 'prizeType', value)}
                    >
                      <SelectTrigger className="w-32">
                        <SelectValue placeholder="Prize type" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="CASH">CASH</SelectItem>
                        <SelectItem value="PRODUCT">PRODUCT</SelectItem>
                      </SelectContent>
                    </Select>
                    {isProductPrize ? (
                      <Input
                        className="w-44"
                        placeholder="Product name"
                        value={edit.label}
                        onChange={(e) => handleComboEditChange(combo._id, 'label', e.target.value)}
                      />
                    ) : (
                      <>
                        <Input
                          className="w-28"
                          placeholder="Amount"
                          value={edit.amount}
                          onChange={(e) => handleComboEditChange(combo._id, 'amount', e.target.value)}
                        />
                        <Input
                          className="w-40"
                          placeholder="Description (optional)"
                          value={edit.label}
                          onChange={(e) => handleComboEditChange(combo._id, 'label', e.target.value)}
                        />
                      </>
                    )}
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => handleSaveComboWinning(combo._id)}
                      className="text-indigo-600 hover:bg-indigo-50"
                      title="Save changes"
                    >
                      <Save className="h-4 w-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => handleDeleteComboWinning(combo._id)}
                      className="text-red-600 hover:bg-red-50"
                      title="Delete combo winning"
                    >
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                  );
                })
              )}
            </div>

            <Separator />

            <div>
              <h3 className="font-medium mb-2">Add combo prize</h3>
              <div className="grid gap-3 sm:grid-cols-2">
                <div>
                  <label className="text-xs font-medium">Ranks (comma-separated)</label>
                  <Input
                    placeholder="100,150,200"
                    value={comboForm.comboRanks}
                    onChange={(e) => setComboForm({ ...comboForm, comboRanks: e.target.value })}
                  />
                </div>
                <div>
                  <label className="text-xs font-medium">Prize type</label>
                  <Select
                    value={comboForm.prizeType}
                    onValueChange={(value) => setComboForm({ ...comboForm, prizeType: value })}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Prize type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="CASH">CASH</SelectItem>
                      <SelectItem value="PRODUCT">PRODUCT</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label className="text-xs font-medium">
                    {comboForm.prizeType === 'PRODUCT' ? 'Product name' : 'Amount (₹)'}
                  </label>
                  {comboForm.prizeType === 'PRODUCT' ? (
                    <Input
                      placeholder="e.g. iPhone 15, Gold coin"
                      value={comboForm.label}
                      onChange={(e) => setComboForm({ ...comboForm, label: e.target.value })}
                    />
                  ) : (
                    <Input
                      placeholder="500"
                      value={comboForm.amount}
                      onChange={(e) => setComboForm({ ...comboForm, amount: e.target.value })}
                    />
                  )}
                </div>
                {comboForm.prizeType === 'CASH' && (
                  <div>
                    <label className="text-xs font-medium">Description (optional)</label>
                    <Input
                      placeholder="Triple rank bonus"
                      value={comboForm.label}
                      onChange={(e) => setComboForm({ ...comboForm, label: e.target.value })}
                    />
                  </div>
                )}
              </div>
            </div>
            </div>

            <div className="shrink-0 flex items-center justify-end gap-2 px-5 py-4 border-t border-gray-200 dark:border-gray-700">
              <Button onClick={handleCreateComboWinning} className="bg-indigo-600 hover:bg-indigo-700">
                <Plus className="h-4 w-4 mr-2" />
                Add Combo Winning
              </Button>
              <Button variant="outline" onClick={handleComboDialogClose}>
                Close
              </Button>
            </div>
          </aside>
        </>
      )}

      <ImageDialog
        open={imageDialogOpen}
        onClose={handleImageDialogClose}
        productId={productId}
        images={imagesData}
      />

      <ProductWishSidebar
        open={productWishSidebarOpen}
        onClose={handleProductWishesClose}
        product={productForWishes}
      />
    </div>
  );
};

export default Products;
